import { Pipe, PipeTransform } from '@angular/core';


export class SimpleFormatPipe implements PipeTransform {
  transform(value: string): any {
    if (!value) return value;

    return (value.split('\n').map(line => '<p>' + line + '</p>')).join('\n');

  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'simpleFormat'}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
